import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { interval, Subscription } from 'rxjs';
import { LoaderService } from '../../../Utils/_services/loader.service';

@Component({
  selector: 'app-loader',
  standalone: true,
 imports: [FormsModule],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.css'
})
export class LoaderComponent {
show = false;

  constructor(private _loaderService: LoaderService) {
    this._loaderService.loading$.subscribe((state) => {
      this.show = state;
    });
  }

  progress = 0;
  private progressSubscription!: Subscription;

  ngOnInit(): void {
    this.progressSubscription = interval(30).subscribe(() => {
      if (this.progress >= 100) {
        this.progress = 0;
      } else {
        this.progress += 1;
      }
    });
  }

  ngOnDestroy(): void {
    this.progressSubscription.unsubscribe();
  }
}